import { useEffect, type ReactNode } from "react"
import { QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"

import { TooltipProvider } from "@/components/ui/tooltip"
import { CookieConsent } from "@/components/cookies/CookieConsent"
import { queryClient } from "@/lib/queryClient"
import { lerPreferencia } from "@/lib/preferencias"
import { obterTemaPadrao } from "@/lib/configuracoesPublicas"
import { useThemeStore, aplicarTemaPadrao, applyTheme } from "@/stores/sessionStore"
import { PresencaHeartbeat } from "./PresencaHeartbeat"

function ThemeSync() {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme)
  useEffect(() => applyTheme(resolvedTheme), [resolvedTheme])
  useEffect(() => {
    // Tema inicial definido pelo administrador: vale apenas para quem ainda
    // não tem preferência salva (o cookie/localStorage do usuário ganha).
    if (lerPreferencia("tema")) return
    let ativo = true
    void obterTemaPadrao().then((tema) => {
      if (ativo && tema) aplicarTemaPadrao(tema)
    })
    return () => {
      ativo = false
    }
  }, [])
  return null
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeSync />
        <PresencaHeartbeat />
        {children}
        <Toaster position="top-right" richColors closeButton />
        <CookieConsent />
      </TooltipProvider>
    </QueryClientProvider>
  )
}